import type { FC, SVGProps } from 'react';

export async function loadAppleWalletBadge(
	lang: string
): Promise<FC<SVGProps<SVGSVGElement>>> {
	const base = (lang || 'en').split('-')[0].toLowerCase();

	try {
		switch (base) {
			case 'cs':
				return (
					await import(
						'../../icons/AppleWallet/CS_Add_to_Apple_Wallet_RGB_101421.svg'
					)
				).default;
			case 'de':
				return (
					await import(
						'../../icons/AppleWallet/DE_Add_to_Apple_Wallet_RGB_101421.svg'
					)
				).default;
			case 'es':
				return (
					await import(
						'../../icons/AppleWallet/ES_Add_to_Apple_Wallet_RGB_101921.svg'
					)
				).default;
			case 'fr':
				return (
					await import(
						'../../icons/AppleWallet/FR_Add_to_Apple_Wallet_RGB_102921.svg'
					)
				).default;
			case 'it':
				return (
					await import(
						'../../icons/AppleWallet/IT_Add_to_Apple_Wallet_RGB_101821.svg'
					)
				).default;
			case 'pl':
				return (
					await import(
						'../../icons/AppleWallet/PL_Add_to_Apple_Wallet_RGB_102121.svg'
					)
				).default;
			case 'tr':
				return (
					await import(
						'../../icons/AppleWallet/TR_Add_to_Apple_Wallet_RGB_102121.svg'
					)
				).default;
			case 'uk':
				return (
					await import(
						'../../icons/AppleWallet/UK_Add_to_Apple_Wallet_RGB_102121.svg'
					)
				).default;
			case 'en':
				return (
					await import(
						'../../icons/AppleWallet/EN_Add_to_Apple_Wallet_RGB_101421.svg'
					)
				).default;
			default:
				console.warn(
					`Apple Wallet badge not available for language '${lang}'. Falling back to English.`
				);
				return (
					await import(
						'../../icons/AppleWallet/EN_Add_to_Apple_Wallet_RGB_101421.svg'
					)
				).default;
		}
	} catch (e) {
		console.error(
			`Failed to load Apple Wallet badge for language '${lang}'`,
			e
		);
		return (
			await import(
				'../../icons/AppleWallet/EN_Add_to_Apple_Wallet_RGB_101421.svg'
			)
		).default;
	}
}
